export enum EVENT_SUBMISSION_SELECTED_STATUS {
  selected = 'selected',
  notSelected = 'not-selected',
}
